import styled from 'styled-components';
import {
  IconButton,
  Badge,
  Drawer,
  Card,
  IconMenu,
  MenuItem,
  CardActionArea,
  Link
} from '@sumtotal/react-foundation';
import { darken } from 'polished';

/* Notifications component styles */
export const NotificationsIconButton = styled(IconButton)`
  padding: 0.425rem 0.3rem;
  color: ${(props) => props.theme.variables.headerBarColor};
  &.Mui-disabled {
    color: ${(props) => props.theme.variables.headerBarColor};
    opacity: 0.5;
  }
  &:focus {
    background-color: ${(props) => props.theme.variables.leftNavHeaderBackground};
    outline: -webkit-focus-ring-color auto 0.0625rem;
  }
`;

export const StyledBadge = styled(Badge)`
  & .MuiBadge-badge {
    height: 1.25rem;
    font-weight: 700;
    font-size: 0.688rem;
    line-height: 0.938rem;
    top: calc(50% - 0.938rem / 2 - 0.031rem);
  }
  & .MuiBadge-colorPrimary {
    color: ${(props) => props.theme.variables.headerBarColor};
    border-color: ${(props) => props.theme.variables.headerBarColor};
  }
`;

export const StyledDrawer = styled(Drawer)`
  .MuiPaper-root {
    width: 30rem;
    height: calc(100% - 6.688rem);
    top: 3.25rem;
    left: calc(100% - 30rem);
    border-radius: 0.25rem;
    border: 0.063rem solid #fff;
    box-shadow: 0rem 0.063rem 0.188rem 0rem rgba(0, 0, 0, 0.16),
      0rem 0rem 0.125rem 0rem rgba(0, 0, 0, 0.16), 0rem 0.125rem 0.125rem 0rem rgba(0, 0, 0, 0.16);
  }
  .MuiFormControlLabel-root {
    padding-left: 1rem;
    margin-top: 0.625rem;
    font-size: 0.875rem;
    font-weight: 400;
  }
  . MuiSwitch-root {
    width: 3.313rem;
  }
  .PrivateSwitchBase-root.MuiSwitch-switchBase.MuiSwitch-colorPrimary {
    padding: 0.375rem !important;
  }
  .MuiSwitch-thumb {
    width: 1rem;
    height: 1rem;
  }
  .MuiSwitch-track {
    margin-top: -0.25rem;
    margin-left: 0.15rem;
    width: 60%;
    height: 90%;
  }
  .MuiFormControlLabel-label {
    margin-top: -0.675rem;
    margin-left: -0.75rem;
  }
  .MuiSwitch-input {
    left: -15%;
    width: 160%;
  }
  .Mui-checked > .MuiSwitch-input {
    left: -70%;
    width: 160%;
  }
`;

export const NotificationHeader = styled.h2`
  padding-left: 1rem;
  width: 30rem;
`;

export const NotificationHeading = styled.h3`
  padding-left: 1rem;
`;

/* Notification Card styles */

export const StyledCard = styled(Card)`
  width: 100% !important;
  height: auto !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  position: relative;
  top: 0 !important;
  bottom: 0 !important;

  &:hover,
  &:focus,
  &:focus-within {
    .styled-link,
    .colored-activity-name {
      color: ${(props) => darken(0.05, props.theme.variables.btnPrimaryBg)};
    }
  }
`;

export const CardContentDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

export const NotificationDot = styled.div`
  width: 1.5rem;
  padding-left: 0.5rem;
  padding-top: 1.69rem;
  div {
    width: 1rem;
  }
  .MuiSvgIcon-root {
    color: ${(props) => props.theme.variables.btnPrimaryBg};
  }
`;

export const ContentDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  padding-left: 1rem;
  padding-bottom: 2.7rem;
  padding-right: 1rem;
`;

export const NameDiv = styled.div`
  font-size: 0.875rem;
  font-weight: 700;
  line-height: normal;
`;

export const StyledSpan = styled.span`
  padding-left: 0.5rem;
  color: #555555;
  text-align: right;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: normal;
`;

export const SrOnlySpan = styled.span`
  position: absolute;
  width: 0.0625rem;
  height: 0.0625rem;
  margin: -0.0625rem;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;

export const DescriptionDiv = styled.div`
  padding-top: 0.25rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: normal;
  word-break: break-word;
`;

export const StyledLink = styled(Link)`
  position: absolute;
  width: max-content;
  font-size: 0.855rem;
  font-weight: 400;
  line-height: normal;
  padding: 0;
  text-transform: capitalize;
  left: 4.375rem;
  bottom: 1rem;

  &:hover,
  &:focus {
    color: ${(props) => darken(0.05, props.theme.variables.btnPrimaryBg)};
  }
`;

export const CardActionsDiv = styled.div`
  margin-top: 18px;
`;

export const NotificationCardDivider = styled.div`
  height: 0.05rem;
  opacity: 0.5;
  background: #767676;
`;

export const NotificationCardsDiv = styled.div`
  margin-top: 0.75rem;
`;

export const NotificationList = styled.ul`
  list-style-type: none;
  width: 100%;
  padding-left: 0rem;
  margin-top: 0rem;
`;

export const NotificationListItem = styled.li`
  width: 100%;
`;

export const NotificationDateCategoryHeader = styled.span`
  margin-top: -0.25rem;
  margin-bottom: -0.875rem;
  padding-left: 1rem;
  color: #555;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const ScrollContainer = styled.div`
  overflow: auto;
  .ScrollbarsCustom-Wrapper {
    margin-top: 3rem;
  }
  .ScrollbarsCustom-Content {
    padding: 0rem !important;
  }
  .StyledCustomScroll {
    &[style] {
      & .ScrollbarsCustom-TrackY {
        height: calc(100% - 3.313rem) !important;
        top: 3.063rem !important;
      }
    }
  }
`;

export const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
`;
export const StyledIconMenu = styled(IconMenu)`
  width: 1.625rem;
  margin: 0.7rem 0.5rem 0.5rem 0.5rem;
  .MuiPopper-root {
    z-index: 9999;
  }
  .MuiPaper-root {
    width: auto !important;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  height: 1.75rem;
  padding: 0.5rem 1rem 0.5rem 1rem;
  justify-content: center;
  color: ${(props) => props.theme.variables.btnPrimaryBg};
`;
export const StyledDivider = styled.div`
  height: 0.1rem;
  opacity: 0.5;
  background: #767676;
`;
export const MenuContainer = styled.div`
  display: flex;
`;

export const ViewMoreButtonContainer = styled.div`
  justify-content: center;
  display: flex;
  padding-bottom: 1.5rem;
`;
export const StyledDiv = styled.div`
  margin-top: 8.125rem;
  margin-left: 6.25rem;
  opacity: 50%;
`;
export const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
`;
export const StyledCardActionArea = styled(CardActionArea)`
  :hover .MuiCardActionArea-focusHighlight {
    opacity: 0.04 !important;
  }
`;

export const IconContainer = styled.div`
  width: 1.875rem;
  padding-top: 1rem;
`;
export const IconDiv = styled.div`
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 50%;
  background-color: ${(props) => props.theme.variables.btnPrimaryBg};
  color: ${(props) => props.theme.variables.btnPrimaryColor};
  padding: 0.3rem 0.313rem 0.3rem 0.39rem;
  div {
    width: 1.25rem;
  }
`;
export const ColoredActivityName = styled.span`
  color: ${(props) => props.theme.variables.btnPrimaryBg};

  &:hover,
  &:focus {
    color: ${(props) => darken(0.05, props.theme.variables.btnPrimaryBg)};
  }
`;
